import styled from 'styled-components'
import {   Button } from 'react-bootstrap'


export const BlogInfo = styled.div`
padding: 10px 20px;
background-color: white;
img{
    width: 100%;
    height: 250px;
    margin-bottom: 10px;
}
h6{
    font-size: 19px;
    font-weight: 700;
    margin: 10px 0px;
}
>p{
    font-size: 13px;
    margin: 20px 0px;
}
`;

export const WriteInfo = styled.div`
display: flex;
justify-content: space-between;
padding: 8px 9px;
background-color: #f6f6f6;
border-radius: 5px;
border-left: 10px solid var(--primaryColor);
>div{
i{
    font-size: 12px;
    margin-right: 6px;
    color: #6f6f6f;
}
span{
    font-size: 12px;
    color: black;
}
}
`;
export const OtherInfo = styled.div`
padding: 20px;
background-color: white;
margin-bottom: 20px;
border-radius:5px;
`;

export const Item = styled.div`
>div{
    margin:20px 0px
}
h6{
    padding: 10px;
    background-color: #f6f6f6;
    font-weight: 600;
    border-left: 10px solid var(--primaryColor);
    font-size: 12px;
    border-radius: 5px;
}
form{
    display: flex;
    margin: 20px 0px;
}
`;

export const SearchBtn = styled(Button)`
border-radius: 4px;
margin-left: -38px;
display: inline-block;
background-color: var(--primaryColor);
border-color:var(--primaryColor);
`;
export const BlogTags = styled.div`
    display:flex;
    flex-wrap:wrap;
`;
